import { EDITOR_FILE_MAX_SIZE } from 'common/constants/files';
import { useContentEditor } from 'common/components/ContentEditor/hooks/useContentEditor';
import { options } from 'common/components/ContentEditor/options';
import {
    IToolbarButtonProps,
    ToolbarButton,
} from 'common/components/ContentEditor/components/EditorToolbar/ToolbarButton';

import { FileUpload } from './FileUpload';
import { addOrReplaceFile } from './utils';

interface IProps extends IToolbarButtonProps {
    file?: typeof options.file;
}

export const ToolbarFile = ({
    file = options.file,
    tooltip,
    ...other
}: IProps) => {
    const editor = useContentEditor();

    const handleSuccess = (url: string, name?: string) => {
        addOrReplaceFile(editor, url, name);
    };

    return (
        <FileUpload
            id="toolbar-file-upload"
            maxSize={EDITOR_FILE_MAX_SIZE}
            onSuccess={handleSuccess}
        >
            <ToolbarButton
                active={editor.api.some({ match: { type: file.type } })}
                tooltip={tooltip}
                {...other}
            />
        </FileUpload>
    );
};
